module.exports = __webpack_public_path__ + "img/350.6f5a0846.png";